import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import hero1 from "../assets/TIG Website Images/Our Businesses/Vodafone Distribution/VodafoneDepartment.png";
import vodaImg from "../assets/vodafone-1.png";
import vodaCollabImg from "../assets/vodafone-bg.png";
import vodaCollabImg2 from "../assets/vodafone-2.png";
import { FaArrowRight } from "react-icons/fa"; 
import vodafoneMap from "../assets/vodafone-3.png"; 
const Vodafone = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
    });
  }, []);

  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid p-0">
<div
  className="hero-section"
  style={{ backgroundImage: `url(${hero1})` }}
>
          <div className="carousel-caption d-flex flex-column align-items-center justify-content-center text-center h-100">
            <div className="col-lg-10 zoom-in-text">
              <p className="text-uppercase text-light m-0">YOUR PARTNER IN SUCCESS</p>
              <h1 className="display-4 fw-bold text-light mb-4 animated slideInDown">
                Vodafone Distribution
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Vodafone Distribution Section */}
      <div className="container my-5">
        <div className="row align-items-center">
          <div className="col-lg-6 mb-4 mb-lg-0" data-aos="fade-up">
            <h1 className="fw-bold mb-3">Vodafone Distribution</h1>
            <p className="text-muted fs-4">
              The collaboration between Tower International Group LLC and Vodafone Oman represents a coming together of
              industry leaders with a shared vision to enhance the distribution of SIM cards and recharge services across
              Oman. This partnership leverages the strengths of both organizations.
            </p>
          </div>
          <div className="col-lg-6 text-center" data-aos="fade-up">
            <img
              src={vodaImg}
              alt="Vodafone Distribution"
              className="img-fluid rounded shadow"
              style={{ maxHeight: "400px", objectFit: "cover" }}
            />
          </div>
        </div>
      </div>

    {/* TIG & Vodafone Collaboration Section */}
<div
  className="container-fluid py-5"
  style={{
    backgroundImage: `url(${vodaCollabImg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  }}
>
  <div className="container">
    <div className="row text-white">
    
<div className="col-lg-6 mb-4 mb-lg-0" data-aos="fade-up">
  <img
    src={vodaCollabImg2}
    alt="Vodafone Collaboration"
    className="img-fluid rounded vodafone-image"
  />
</div>

  <div className="col-lg-6 text-start text-md-start" data-aos="fade-up">
 <h6 className="section-subtitle">TIG & Vodafone Collaboration</h6>
  <h2 className="section-title">
    Empowering Connectivity <br />Through Strategic Alliances
  </h2>
     <ul className="custom-list">
        <li><span className="icon-circle"><FaArrowRight /></span> Partnership with Banks</li>
        <li><span className="icon-circle"><FaArrowRight /></span> Partnership with Corporates</li>
        <li><span className="icon-circle"><FaArrowRight /></span> Partnership with Hypermarkets</li>
        <li><span className="icon-circle"><FaArrowRight /></span> POS Machines</li>
        <li><span className="icon-circle"><FaArrowRight /></span> Vodafone Dealer Distribution</li>
      </ul>

</div>

    </div>
  </div>
</div>
 {/* Vodafone Presence Map Section */}
      <div className="container-fluid my-5 text-center" data-aos="fade-up">
        <h2 className="fw-bold mb-3">Vodafone Presence in Oman</h2>
        {/* <p className="text-muted fs-5 mb-4">
          Our Vodafone services are freely available in 30 countries marked in red on the map.
        </p> */}
        {/* <img
          src={vodafoneMap}
          alt="Vodafone Map"
          className="img-fluid rounded "
          style={{ width: "100%", objectFit: "contain" }}
        /> */}
     <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.6324483710346!2d58.3979431!3d23.5816407!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e91ff19b8247351%3A0xd5b578337f73c6db!2sTIG%20(Towers%20International%20Group%20of%20Companies)!5e0!3m2!1sen!2sin!4v1763457995185!5m2!1sen!2sin"
  width="100%"
  height="450"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

      </div>
    
    </div>
  );
};

export default Vodafone;
